import { cssThemedValue } from '@creditornot/cb-ingredients';
import React from 'react';
import { useRouteMatch } from 'react-router-dom';
import styled from 'styled-components';

import MenuLinkItemRRD from 'common/components/MenuLinkItemRRD';
import { MOBILE_BREAKPOINT } from 'common/hooks/useIsMobile';

type ItemT = {
  href: string;
  name: string;
};

type Props = {
  className?: string;
  items: ItemT[];
};

const Root = styled.div`
  padding: 24px;
  display: flex;
  gap: 8px;
  margin-block-end: 24px;
  border-block-end: 1px solid ${cssThemedValue('borderPrimary')};

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    align-items: flex-start;
    flex-direction: column;
  }
`;

const StyledMenuLinkItemRRD = styled(MenuLinkItemRRD)`
  padding: 12px;
  border: 1px solid ${cssThemedValue('borderPrimary')};
`;

const Item = ({ item }: { item: ItemT }) => {
  const match = useRouteMatch({
    path: item.href,
    exact: true,
  });
  return (
    <StyledMenuLinkItemRRD key={item.href} href={item.href} active={!!match}>
      {item.name}
    </StyledMenuLinkItemRRD>
  );
};

const AccessManagementNavigation = ({ items }: Props) => {
  return (
    <Root>
      {items.map(item => (
        <Item key={item.href} item={item} />
      ))}
    </Root>
  );
};

export default AccessManagementNavigation;
